<template>
  <Alert type="warning" v-if="isTimezoneDifferent" class="rounded-none">
    <!-- prettier-ignore -->
    <template #description>
      Your time zone has changed from
      <span class="font-medium">{{ timezone }}</span>
      to
      <span class="font-medium">{{ browserTimezone }}</span>.
      <button class="link" @click="synchroniseTimezone">Synchronise!</button>
    </template>
  </Alert>
</template>

<script setup>
import Alert from '@/shared/components/Alert.vue'
import { useForm } from '@inertiajs/vue3'
import { computed, onMounted, ref } from 'vue'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import { notify } from '@kyvg/vue3-notification'

const { timezone } = useCurrentUser()
const form = useForm({})

const browserTimezone = ref(timezone.value)

onMounted(() => {
  browserTimezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone
})

const isTimezoneDifferent = computed(
  () => browserTimezone.value !== timezone.value,
)

const synchroniseTimezone = () => {
  form
    .transform(() => ({
      timezone: browserTimezone.value,
    }))
    .put('/settings/profile/basic/sync_timezone', {
      preserveScroll: true,
      onSuccess: () => {
        notify({
          type: 'success',
          text: `Your timezone has been updated to ${browserTimezone.value}. Your page will be reloaded to synchronise your changes.`,
        })

        // TIMEZONE SYNCHRONISATION: Reload the entire page to update all components to use the new timezone.
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      },
    })
}
</script>
